import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * HTTP Interceptor to prevent caching of API responses
 * Uses cache-busting query parameter (non-invasive, no CORS issues)
 */
@Injectable()
export class NoCacheInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only apply to POST/PUT requests (not GET, OPTIONS, etc.)
    if (request.method === 'POST' || request.method === 'PUT') {
      // Add a cache-busting parameter with current timestamp
      const timestamp = new Date().getTime();
      const separator = request.url.includes('?') ? '&' : '?';
      const url = `${request.url}${separator}_t=${timestamp}`;
      
      const modifiedRequest = request.clone({ url });
      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }
}

